import { memo, useCallback, useState } from 'react';

import TermsAndConditionsView from './components/terms-and-conditions-view/terms-and-conditions-view';

type TranslateFn = (key: string, options?: { ns?: string[] }) => string;

type TermsAndConditionsConfig = Readonly<{
  t: TranslateFn;
  text?: string;
}>;

export type TermsAndConditionsPropsType = Readonly<{
  value?: boolean;
  onChange?: (value: boolean) => void;
  text?: string;
  error?: string;
  config?: TermsAndConditionsConfig;
}>;

const TermsAndConditions = ({ onChange, text, config, value = false, error }: TermsAndConditionsPropsType) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const changeStateOfModal = useCallback((status: boolean) => {
    setIsModalOpen(status);
  }, []);

  const handleChange = useCallback(
    (checked: boolean) => {
      onChange?.(Boolean(checked));
    },
    [onChange],
  );

  return (
    <TermsAndConditionsView
      text={text ?? config?.text}
      onChange={handleChange}
      error={error}
      value={value}
      t={config?.t}
      isModalOpen={isModalOpen}
      changeStateOfModal={changeStateOfModal}
    />
  );
};

export default memo(TermsAndConditions);
